import { Link } from 'react-router-dom';
import { PageLayout } from '../layouts/PageLayout';
import { SEOHead } from '../components/seo/SEOHead';

export function NotFound() {
  return (
    <PageLayout>
      <SEOHead title="404 — Page Not Found" noIndex />
      <div className="flex flex-col items-start gap-4 py-10">
        <p className="font-mono text-5xl text-[var(--color-accent)]/40 font-light">404</p>
        <h1 className="font-serif text-3xl text-[var(--color-text)]">Page not found</h1>
        <p className="text-[var(--color-muted)] max-w-sm">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="mt-2 text-sm text-[var(--color-accent)] hover:underline font-mono tracking-wide"
        >
          ← back to home
        </Link>
      </div>
    </PageLayout>
  );
}
